<div fxLayout="column" class="full-height" fxLayoutAlign="center center">
  <h1 class="mat-headline">There's nothing here. 👨🏽‍💻</h1>

  <div fxLayout="row" fxLayoutGap="25px">
    <button mat-raised-button (click)="goBack()">Go Back</button>
    <button color="primary" mat-raised-button routerLink="/">Go Home</button>
  </div>
</div>